import React, { useEffect, useRef, useState } from "react";
import App from "../LayoutMobile";
import "./partner.css";
import {
  Card,
  ConfigProvider,
  Form,
  message,
  Pagination,
  Checkbox,
  Upload,
  Popover,
  Table,
  Input,
  Select,
  Button,
  Space,
  Popconfirm,
  Typography,
  Row,
  Col,
  Spin,
} from "antd";
import {
  CheckOutlined,
  CloseCircleOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PaperClipOutlined,
  SearchOutlined,
  SwitcherOutlined,
} from "@ant-design/icons";
import {
  QuestionCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import axios from "axios";

import { Config } from "../Common/Config";
import { useForm } from "antd/es/form/Form";
import PartnerCard from "./PartnerCard";

const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;

const Partner = () => {
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [allPartnerData, setAllPartnerData] = useState({});
  const [partnerDataInUpdate, setPartnerDataInUpdate] = useState({});
  const [CurrentPage, setCurrentPage] = useState(1);
  const [corporateProducts, setCorporateProducts] = useState([]);
  const [productCategories, setProductCategories] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [isPartnerCreateEnable, setisPartnerCreateEnable] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [fileList, setFileList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [openDropdownIdx, setOpenDropdownIdx] = useState(null);
  const [base64Image, setBase64Image] = useState(null);
  const [showAddButton, setshowAddButton] = useState(true);
  const [loader, setloader] = useState(false);
  const [showEditorOnlyAdd, setshowEditorOnlyAdd] = useState(true);
  const [copied, setCopied] = useState(false);
  const [copiedSlug, setCopiedSlug] = useState(false);
  const [showMiddleSection, setShowMiddleSection] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [showWidgetField, setShowWidgetField] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [limit, setLimit] = useState(20);
  const [letter, setLetter] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [catSearchValue, setCatSearchValue] = useState("");
  // Tracks whether "All" is selected in the category dropdown.
  // categoryCustomizations may contain per-category entries even in All mode.
  const [isCategoryAllMode, setIsCategoryAllMode] = useState(true);
  // Category customization state
  const [categoryCustomizations, setCategoryCustomizations] = useState([]);
  const [categoryLabelErrors, setCategoryLabelErrors] = useState({});
  const [categoryCustomizationError, setCategoryCustomizationError] = useState(false);
  const [productRequiredError, setProductRequiredError] = useState(false);

  // â”€â”€ Slug update state (edit mode only) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [isSlugUpdating, setIsSlugUpdating] = useState(false);
  // recommendedSlug is populated when the backend says isValid:false (conflict)
  const [recommendedSlug, setRecommendedSlug] = useState("");
  // Controls whether the slug field is in editable mode (default: disabled)
  const [isSlugEditing, setIsSlugEditing] = useState(false);
  // In Add mode: tracks whether the current slug value has been validated
  const [isSlugValidated, setIsSlugValidated] = useState(false);

  const [form] = useForm();

  useEffect(() => {
    getPartners(letter, CurrentPage, limit, debouncedSearch);
    getCorporateProducts();
    getProductCategories();
  }, [letter, CurrentPage, limit, debouncedSearch]);

  // 500 ms debounce on search
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm.trim());
    }, 500);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  // â”€â”€ API: List Partners â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const getPartners = async (
    letter = "",
    page = 1,
    limit = 20,
    search = ""
  ) => {
    setLoading(true);
    try {
      let url = `${Config.url}partners/page/${page}`;
      const params = [];
      if (letter && letter !== "ALL")
        params.push(`letter=${letter.toLowerCase()}`);
      if (search) params.push(`search=${encodeURIComponent(search)}`);
      if (params.length) url += `?${params.join("&")}`;

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setAllPartnerData(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.log("error in getPartners ::::", error);
      messageApi.error({
        type: "error",
        content:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
      setLoading(false);
    }
  };

  // â”€â”€ API: Get D2C Products â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const getCorporateProducts = async () => {
    try {
      const response = await axios.get(
        `${Config.url}get-d2c-products`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setCorporateProducts(response?.data?.data);
    } catch (error) {
      console.log("error in getCorporateProducts ::::", error);
      messageApi.error({
        type: "error",
        content:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
    }
  };

  // â”€â”€ API: Get Product Categories â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const getProductCategories = async () => {
    try {
      const response = await axios.get(
        `${Config.url}product-category/page/1?per_page=-1`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      // API returns data.data.data (paginated list); field is product_category_id
      const raw = response?.data?.data;
      const all = Array.isArray(raw) ? raw : raw?.data ?? [];
      setProductCategories(all.filter((c) => c.type === "d2c"));
    } catch (error) {
      console.log("error in getProductCategories ::::", error);
    }
  };

  // â”€â”€ Base64 helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const beforeUpload = async (file) => {
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("File size must be smaller than 2MB!");
      return Upload.LIST_IGNORE;
    }
    const base64 = await getBase64(file);
    setBase64Image(base64);
    setFileList([file]);
    form.setFieldsValue({ company_logo: base64 });
    return false;
  };

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (newFileList.length === 0) {
      setBase64Image(null);
      form.setFieldsValue({ company_logo: null });
    }
  };

  // â”€â”€ Columns â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const columns = [
    {
      title: "Partner name",
      dataIndex: "name",
      key: "name",
      align: "left",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "left",
      render: (_, record) => (record?.status == 1 ? "Active" : "Inactive"),
    },
    {
      title: "Main Widget Exclusion",
      key: "exclude_category",
      align: "left",
      render: (_, record) => {
        const excluded = (record?.category_customization || []).filter(
          (cat) => cat?.exclude_category === true
        );
        if (excluded.length === 0) return <span style={{ color: "#aaa" }}>—</span>;
        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
            {excluded.map((cat, i) => {
              const catName =
                productCategories.find(
                  (c) =>
                    Number(c.product_category_id) ===
                    Number(cat.product_category_id)
                )?.name || `Category ${cat.product_category_id}`;
              return (
                <span
                  key={i}
                  style={{
                    background: "#e6f7f7",
                    border: "1px solid #b5e3e3",
                    color: "#008385",
                    borderRadius: 4,
                    padding: "1px 8px",
                    fontSize: 12,
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                  }}
                >
                  {catName}
                </span>
              );
            })}
          </div>
        );
      },
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <div style={{ textAlign: "right", marginRight: 2 }}>
          <Popover
            placement="left"
            trigger="click"
            content={() => popoverContent(record)}
          >
            <button
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontWeight: 700,
                fontSize: 18,
                letterSpacing: 2,
                color: "#008385",
                padding: "0 6px",
                lineHeight: 1,
              }}
            >
              &middot;&middot;&middot;
            </button>
          </Popover>
        </div>
      ),
    },
  ];

  // â”€â”€ Pagination itemRender â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") return <a style={{ color: "#4A4A4A" }}>Previous</a>;
    if (type === "next") return <a style={{ color: "#4A4A4A" }}>Next</a>;
    return originalElement;
  };

  // â”€â”€ Alphabet filter â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const alphabets = Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode(65 + i)
  );
  const buttons = ["ALL", ...alphabets];

  const onClickAlphabets = (letter, index) => {
    getPartners(letter);
    setActiveIndex(index);
    setLetter(letter);
    setCurrentPage(1);
  };

  // â”€â”€ Open form (view or edit) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const openPartnerForm = (record, viewMode = false) => {
    setShowMiddleSection(false);
    setshowAddButton(false);
    setloader(true);
    setIsViewMode(viewMode);
    setisPartnerCreateEnable(true);
    setPartnerDataInUpdate(record);
    setshowEditorOnlyAdd(false);
    setShowWidgetField(true);

    const productIds =
      record.corporate_products?.map((p) => p.non_gp_product_id) || [];

    const logoFileList = record.company_logo
      ? [
        {
          uid: "-1",
          name: record.company_logo.split("/").pop(),
          status: "done",
          url: record.company_logo,
        },
      ]
      : [];

    setFileList(logoFileList);
    setSelected(productIds);

    // Load category_customization — distribute product IDs into each block
    const loadedCategories = Array.isArray(record.category_customization)
      ? record.category_customization
      : [];

    // Flat list of product IDs this partner already has
    const partnerProductIds = (record.corporate_products || []).map(
      (p) => p.non_gp_product_id
    );

    // Use global corporateProducts (has accurate product_category_id) to
    // look up which category each partner product belongs to
    const partnerProductsWithCategory = partnerProductIds.map((pid) => {
      const globalProduct = corporateProducts?.find(
        (gp) => gp.non_gp_product_id === pid
      );
      return {
        non_gp_product_id: pid,
        product_category_id: globalProduct?.product_category_id ?? null,
      };
    });

    const categoriesWithProducts = loadedCategories.length > 0
      ? loadedCategories.map((cat) => {
        const isAllBlock = cat.product_category_id == null;
        const blockProductIds = isAllBlock
          // "All" block: products whose category is NOT covered by a specific block
          ? partnerProductsWithCategory
            .filter((p) => {
              const takenBySpecificBlock = loadedCategories.some(
                (c) =>
                  c.product_category_id != null &&
                  Number(c.product_category_id) === Number(p.product_category_id)
              );
              return !takenBySpecificBlock;
            })
            .map((p) => p.non_gp_product_id)
          // Specific block: products that belong to this exact category
          : partnerProductsWithCategory
            .filter(
              (p) =>
                Number(p.product_category_id) === Number(cat.product_category_id)
            )
            .map((p) => p.non_gp_product_id);

        return {
          ...cat,
          exclude_category: cat.exclude_category ?? false,
          non_gp_product_ids: blockProductIds,
        };
      })
      : [];

    setCategoryCustomizations(categoriesWithProducts);

    form.setFieldsValue({
      name: record.name || "",
      email: record.email || "",
      slug_name: record.slug_name || "",
      intranet_url: record.intranet_url || "",
      page_url: record.page_url || "",
      allow_for_admin: !!record.allow_for_admin,
      hide_consultation_form: !!record.hide_consultation_form,
      clinic_label: record.clinic_label || "",
      non_gp_product_ids: productIds || [],
      widget_url: record.widget_url || "",
      company_logo: record.company_logo || "",
      // requires_employee_number intentionally omitted
    });
    setloader(false);

    document
      .querySelector(".productcategory-form")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  // â”€â”€ Popover content â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const popoverContent = (record) => {
    return (
      <div
        className="rule-action-popover"
        style={{ display: "flex", flexDirection: "column", padding: "4px 0" }}
      >
        <div
          className="rule-action-item"
          style={{ color: "#008385" }}
          onClick={(e) => {
            e.stopPropagation();
            openPartnerForm(record, true);
          }}
        >
          <EyeOutlined style={{ fontSize: 15 }} /> View
        </div>
        <div
          className="rule-action-item"
          style={{ color: "#008385" }}
          onClick={(e) => {
            e.stopPropagation();
            openPartnerForm(record, false);
          }}
        >
          <EditOutlined style={{ fontSize: 15 }} /> Edit
        </div>
        <div className="rule-action-divider" />
        <Popconfirm
          title="Update status"
          description="Are you sure you want to update status?"
          onConfirm={() => updatePartnerStatus(record)}
          icon={<QuestionCircleOutlined style={{ color: "red" }} />}
          okButtonProps={{ className: "confirmation-popup-ok-button" }}
          cancelButtonProps={{ className: "confirmation-popup-cancel-button" }}
          okText="Yes"
          cancelText="No"
        >
          <div className="rule-action-item" style={{ color: "#008385" }}>
            <SwitcherOutlined style={{ fontSize: 15 }} />
            {record && record.status == 1 ? "Make Inactive" : "Make Active"}
          </div>
        </Popconfirm>
        <div className="rule-action-divider" />
        <Popconfirm
          title="Delete"
          description="Are you sure you want to delete?"
          onConfirm={() => deletePartner(record)}
          icon={<QuestionCircleOutlined style={{ color: "red" }} />}
          okButtonProps={{ className: "confirmation-popup-ok-button" }}
          cancelButtonProps={{ className: "confirmation-popup-cancel-button" }}
          okText="Yes, Delete"
          cancelText="Cancel"
        >
          <div className="rule-action-item rule-action-item--delete">
            <DeleteOutlined style={{ fontSize: 15 }} /> Delete
          </div>
        </Popconfirm>
      </div>
    );
  };

  // â”€â”€ Create / Update â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const handlePartnerCreate = async (values, update = false) => {
    // â”€â”€ Validate: at least 1 category customization required â”€â”€
    if (categoryCustomizations.length === 0) {
      setCategoryCustomizationError(true);
      messageApi.error({
        type: "error",
        content: "At least 1 Category Customization is required.",
      });
      return;
    }
    setCategoryCustomizationError(false);

    // ── Validate: at least 1 product required ──
    const totalProducts = categoryCustomizations.flatMap(c => c.non_gp_product_ids || []).length;
    if (totalProducts === 0) {
      setProductRequiredError(true);
      messageApi.error({ type: "error", content: "At least 1 Product is required." });
      return;
    }
    setProductRequiredError(false);

    // â”€â”€ Validate: Category Label required when checkbox is checked â”€â”€
    const labelErrors = {};
    categoryCustomizations.forEach((cat, idx) => {
      if (cat.change_category_label && !cat.product_category_label?.trim()) {
        labelErrors[idx] = "Category Label is required.";
      }
    });
    if (Object.keys(labelErrors).length > 0) {
      setCategoryLabelErrors(labelErrors);
      messageApi.error({
        type: "error",
        content: "Please fill in all required Category Label fields.",
      });
      return;
    }
    setCategoryLabelErrors({});

    // Resolve ID: API may return `id` or `corporate_customer_id`
    const partnerId = partnerDataInUpdate?.corporate_customer_id || partnerDataInUpdate?.id;
    const isUpdate = update && Object.keys(partnerDataInUpdate).length && partnerId;

    const url = !isUpdate
      ? `${Config.url}partners`
      : `${Config.url}partners/${partnerId}`;

    const payload = {
      company_logo: base64Image || partnerDataInUpdate?.company_logo || "",
      name: values.name || "",
      email: values.email || "",
      slug_name: values.slug_name || "",
      allow_for_admin: values.allow_for_admin || false,
      hide_consultation_form: !!values.hide_consultation_form,
      clinic_label: values.clinic_label || "",
      page_url: values.page_url || "",
      intranet_url: values.intranet_url || "",
      non_gp_product_ids: values.non_gp_product_ids || [],
      widget_url: values.widget_url || "",
      category_customization: categoryCustomizations,
      ...(isUpdate ? { _method: "PUT" } : {}),
      // requires_employee_number intentionally omitted
    };

    try {
      setIsSubmitting(true);
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (res.ok && data?.success) {
        messageApi.success({
          type: "success",
          content: !isUpdate
            ? "Partner created successfully"
            : "Partner updated successfully",
        });
        form.resetFields();
        setSelected([]);
        setFileList([]);
        setRecommendedSlug("");
        setCategoryCustomizations([]);
        setProductRequiredError(false);
        getPartners();
        setIsSubmitting(false);
        setisPartnerCreateEnable(false);
        setPartnerDataInUpdate({});
        setIsViewMode(false);
        setshowAddButton(true);
        setCurrentPage(1);
        setLetter("");
        setActiveIndex(null);
      } else {
        // â”€â”€ Surface field-level validation errors from the backend (e.g. 422) â”€â”€
        // errors shape: { slug_name: ["The slug name has already been taken."], ... }
        if (data?.errors && typeof data.errors === "object") {
          const fieldErrors = Object.entries(data.errors).map(
            ([field, messages]) => ({
              name: field,
              errors: Array.isArray(messages) ? messages : [messages],
            })
          );
          form.setFields(fieldErrors);
        } else {
          messageApi.error({
            type: "error",
            content:
              data?.message ||
              (!isUpdate ? "Failed to create partner" : "Failed to update partner"),
          });
        }
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Error saving partner:", error);
      messageApi.error({
        type: "error",
        content:
          error.message ||
          (!update ? "Failed to create partner" : "Failed to update partner"),
      });
      setIsSubmitting(false);
    }
  };

  // â”€â”€ Status toggle â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const updatePartnerStatus = async (record) => {
    // Resolve ID: API may return `id` or `corporate_customer_id`
    const partnerId = record?.corporate_customer_id || record?.id;
    if (!partnerId) return;
    setloader(true);
    const url = `${Config.url}partners/${partnerId}`;
    try {
      const response = await axios.put(
        url,
        { status: record.status == 1 ? 0 : 1 },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response?.data?.success) {
        messageApi.success({
          type: "success",
          content: "Partner status updated successfully",
        });
        getPartners();
      }
    } catch (error) {
      messageApi.error({ type: "error", content: "Something went wrong" });
      console.log("updatePartnerStatus error:", error.response?.data || error.message);
    }
    setloader(false);
  };

  // â”€â”€ Delete â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const deletePartner = async (record) => {
    // Resolve ID: API may return `id` or `corporate_customer_id`
    const partnerId = record?.corporate_customer_id || record?.id;
    if (!partnerId) {
      messageApi.error("Cannot delete: partner ID is missing.");
      return;
    }
    const url = `${Config.url}partners/${partnerId}`;
    try {
      await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      messageApi.success("Partner deleted successfully");
      getPartners();
    } catch (error) {
      console.error("Delete error:", error.response?.data || error.message);
      messageApi.error(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    }
  };

  // â”€â”€ Update Slug (edit mode only) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  // POST /api/admin/v1/partners/validate-slug
  // Body: { slug_name, ignore_id? }
  // Response: { success, isValid, originalSlug, recommendedSlug }
  //   isValid: true  â†’ slug is free, persist via PUT
  //   isValid: false â†’ conflict, show recommendedSlug to the user
  const handleUpdateSlug = async () => {
    const slugValue = form.getFieldValue("slug_name");
    if (!slugValue) {
      messageApi.warning("Slug name cannot be empty.");
      return;
    }

    setRecommendedSlug(""); // clear any previous suggestion
    setIsSlugUpdating(true);
    try {
      const url = `${Config.url}partners/validate-slug`;

      // Build body â€” include ignore_id when editing so the backend skips
      // the current partner's own slug from the uniqueness check.
      const body = { slug_name: slugValue };
      const slugPartnerId = partnerDataInUpdate?.corporate_customer_id || partnerDataInUpdate?.id;
      if (slugPartnerId) {
        body.ignore_id = slugPartnerId;
      }

      const response = await axios.post(url, body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const result = response?.data;
      // Backend shape: { success, message, data: { isValid, originalSlug, recommendedSlug } }
      const resultData = result?.data;

      if (result?.success && resultData?.isValid) {
        // â”€â”€ Slug is valid and available â€” persist via PUT â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
        const updateUrl = `${Config.url}partners/${slugPartnerId}`;
        const res = await fetch(updateUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ slug_name: slugValue, _method: "PUT" }),
        });
        const data = await res.json();
        if (res.ok && data?.success) {
          messageApi.success("Slug is valid and available");
          form.setFields([{ name: "slug_name", errors: [] }]);
          // Refresh local record so re-opening edit reflects the new slug
          setPartnerDataInUpdate((prev) => ({ ...prev, slug_name: slugValue }));
          getPartners();
        } else {
          messageApi.error(data?.message || "Failed to update slug");
        }
      } else if (result?.success && resultData?.isValid === false) {
        // â”€â”€ Conflict â€” backend suggests an alternative slug â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
        const suggestion = resultData?.recommendedSlug || "";
        setRecommendedSlug(suggestion);
        form.setFields([
          {
            name: "slug_name",
            errors: ["Slug name is already in use."],
          },
        ]);
      } else {
        // Unexpected failure
        form.setFields([
          {
            name: "slug_name",
            errors: [result?.message || "Slug validation failed"],
          },
        ]);
      }
    } catch (error) {
      const errMsg =
        error.response?.data?.message ||
        error.message ||
        "Slug validation failed";
      form.setFields([{ name: "slug_name", errors: [errMsg] }]);
    } finally {
      setIsSlugUpdating(false);
    }
  };

  // Validate-only slug check for Add mode (no PUT — just checks availability)
  const handleValidateSlug = async () => {
    const slugValue = form.getFieldValue("slug_name");
    if (!slugValue) {
      messageApi.warning("Slug name cannot be empty.");
      return;
    }
    setRecommendedSlug("");
    setIsSlugValidated(false);
    setIsSlugUpdating(true);
    try {
      const response = await axios.post(
        `${Config.url}partners/validate-slug`,
        { slug_name: slugValue },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const result = response?.data;
      const resultData = result?.data;
      if (result?.success && resultData?.isValid) {
        setIsSlugValidated(true);
        form.setFields([{ name: "slug_name", errors: [] }]);
        messageApi.success("Slug is available!");
      } else if (result?.success && resultData?.isValid === false) {
        const suggestion = resultData?.recommendedSlug || "";
        setRecommendedSlug(suggestion);
        // Use the actual backend message instead of hardcoded text
        form.setFields([{ name: "slug_name", errors: [result?.message || "Slug name is not valid."] }]);
      } else {
        form.setFields([{ name: "slug_name", errors: [result?.message || "Slug validation failed"] }]);
      }
    } catch (error) {
      const errMsg = error.response?.data?.message || error.message || "Slug validation failed";
      form.setFields([{ name: "slug_name", errors: [errMsg] }]);
    } finally {
      setIsSlugUpdating(false);
    }
  };

  // â”€â”€ Widget URL copy â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const handleCopy = () => {
    const value = form.getFieldValue("widget_url");
    if (value) {
      navigator.clipboard.writeText(value);
      setCopied(true);
      message.success("Copied to clipboard!");
      setTimeout(() => setCopied(false), 2000);
    }
  };

  // â”€â”€ Initials for avatar â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    return parts
      .slice(0, 2)
      .map((p) => p[0]?.toUpperCase())
      .join("");
  };

  // Resolve the partner ID regardless of field name (corporate_customer_id vs id)
  const resolvedPartnerId =
    partnerDataInUpdate?.corporate_customer_id || partnerDataInUpdate?.id;

  const isEditingExistingPartner =
    Object.keys(partnerDataInUpdate).length > 0 && !!resolvedPartnerId;

  // â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  return (
    <App>
      {contextHolder}
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "0 16px",
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          {allPartnerData && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                marginBottom: "10px",
              }}
            >
              <Title
                level={5}
                style={{ margin: 0, color: "#008385", fontSize: 20 }}
              >
                All partners{" "}
                <span style={{ color: "black", fontWeight: "400" }}>
                  ({allPartnerData?.total ? allPartnerData.total : "00"})
                </span>
              </Title>
            </div>
          )}
          <div
            style={{
              display: "grid",
              justifyContent: "space-between",
              marginBottom: 15,
            }}
          >
            <Input
              prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
              placeholder="Search for a partner"
              style={{ width: "100%", maxWidth: "215px", height: 40 }}
              onChange={(e) => {
                setCurrentPage(1);
                setSearchTerm(e.target.value);
              }}
            />
          </div>
        </div>
      </div>

      {/* â”€â”€ Partner table â”€â”€ */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Card
          className="addClinic-table"
          style={{
            width: 950,
            margin: 0,
            padding: 0,
            borderRadius: 50,
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
          }}
        >
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#008385",
                  headerColor: "#ffffff",
                },
                Spin: {
                  colorPrimary: "#008385",
                },
              },
            }}
          >
            <Table
              loading={loading}
              className="partner-table"
              columns={columns}
              dataSource={allPartnerData.data}
              pagination={false}
              onRow={(record) => ({
                onClick: () => {
                  setShowMiddleSection(true);
                  setisPartnerCreateEnable(false);
                  setPartnerDataInUpdate(record);
                  setIsSlugEditing(false);
                },
                style: { cursor: "pointer" },
              })}
              scroll={{ x: "auto" }}
            />

            {allPartnerData && allPartnerData?.total ? (
              <Pagination
                align="center"
                pageSize={limit}
                className="partner-pagination"
                total={allPartnerData?.total || 0}
                style={{ marginTop: 10 }}
                current={CurrentPage}
                onChange={(page, size) => {
                  setCurrentPage(page);
                  setLimit(size || 20);
                }}
                itemRender={itemRender}
              />
            ) : (
              ""
            )}

            {/* Alphabet filter */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "4px",
                marginTop: 10,
                justifyContent: "center",
              }}
            >
              {buttons.map((btn, index) => (
                <Button
                  key={btn}
                  type="default"
                  onClick={() => onClickAlphabets(btn, index)}
                  style={{
                    padding: "4px 8px",
                    fontSize: "12px",
                    cursor: "pointer",
                    backgroundColor:
                      activeIndex === index ? "#0083851a" : "#f5f5f5",
                    border:
                      activeIndex === index
                        ? "1px solid #008385"
                        : "1px solid #d9d9d9",
                    color: activeIndex === index ? "#008385" : "inherit",
                    transition: "all 0.2s ease",
                  }}
                >
                  {btn}
                </Button>
              ))}
            </div>
          </ConfigProvider>
        </Card>
      </div>

      {/* â”€â”€ Add Partner button â”€â”€ */}
      {showAddButton && (
        <div
          className="clinicCreate-form button-add-left"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <Button
            className="add-generic-btn"
            onClick={() => {
              setIsViewMode(false);
              form.setFieldsValue({
                name: "",
                email: "",
                slug_name: "",
                intranet_url: "",
                page_url: "",
                allow_for_admin: false,
                hide_consultation_form: false,
                clinic_label: "",
                non_gp_product_ids: [],
                widget_url: "",
                // requires_employee_number intentionally omitted
              });
              setCategoryCustomizations([]);
              setProductRequiredError(false);
              setisPartnerCreateEnable(true);
              setSelected([]);
              setShowMiddleSection(false);
              setShowWidgetField(false);
              setPartnerDataInUpdate({});
              setFileList([]);
              setIsSlugValidated(false);
              setRecommendedSlug("");
            }}
          >
            Add a partner
          </Button>
        </div>
      )}

      {/* â”€â”€ PartnerCard (row-click summary) â”€â”€ */}
      {showMiddleSection && (
        <div
          className="middle-customer-details"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "20px 0",
            padding: "0 16px",
          }}
        >
          <PartnerCard
            setShowMiddleSection={setShowMiddleSection}
            partnerDataInUpdate={partnerDataInUpdate}
            setshowAddButton={setshowAddButton}
          />
        </div>
      )}

      {/* ——— Create / Edit / View form ——— */}
      {isPartnerCreateEnable && (
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 10, padding: "0 16px" }}
        >
          <Card
            className={`productcategory-form${isViewMode ? " view-mode-card" : ""}`}
            style={{ width: "100%", maxWidth: 750, height: "fit-content" }}
            title={
              isViewMode ? (
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #008385, #00a3a5)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 16,
                      flexShrink: 0,
                      boxShadow: "0 2px 6px rgba(0,131,133,0.30)",
                    }}
                  >
                    {getInitials(partnerDataInUpdate?.name)}
                  </div>
                  <span
                    style={{ fontWeight: 700, fontSize: 16, color: "#007a7c" }}
                  >
                    {partnerDataInUpdate?.name || "Partner"}
                  </span>
                </div>
              ) : (
                "Partner details"
              )
            }
          >
            {/* â”€â”€ VIEW MODE â”€â”€ */}
            {partnerDataInUpdate && loader === false && isViewMode ? (
              <div style={{ padding: "0 4px" }}>
                {/* Section: Partner Information */}
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#008385",
                    letterSpacing: 1,
                    textTransform: "uppercase",
                    marginBottom: 8,
                    paddingBottom: 4,
                    borderBottom: "1px solid #c5e8e8",
                  }}
                >
                  Partner Information
                </div>

                <div className="view-detail-row">
                  <label>Partner Name</label>
                  <span className="view-field-value">
                    {partnerDataInUpdate?.name || "-"}
                  </span>
                </div>
                <div className="view-detail-row">
                  <label>Company Email</label>
                  <span className="view-field-value">
                    {partnerDataInUpdate?.email || "-"}
                  </span>
                </div>
                <div className="view-detail-row">
                  <label>Products</label>
                  <span className="view-field-value">
                    {(partnerDataInUpdate?.corporate_products || [])
                      .map((p) => p.name)
                      .join(", ") || "-"}
                  </span>
                </div>
                {/* <div className="view-detail-row">
                  <label>Intranet URL</label>
                  <span className="view-field-value">
                    {partnerDataInUpdate?.intranet_url || "-"}
                  </span>
                </div> */}
                {showWidgetField && (
                  <div className="view-detail-row">
                    <label>Booking Widget id</label>
                    <span className="view-field-value" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      {partnerDataInUpdate?.widget_url || "-"}
                      {partnerDataInUpdate?.widget_url && (
                        <span
                          title={copied ? "Copied!" : "Copy Widget ID"}
                          onClick={() => {
                            navigator.clipboard.writeText(partnerDataInUpdate.widget_url);
                            setCopied(true);
                            setTimeout(() => setCopied(false), 1800);
                          }}
                          style={{ cursor: "pointer", color: copied ? "#008385" : "#aaa", fontSize: 13, transition: "color 0.2s", flexShrink: 0 }}
                        >
                          {copied ? <CheckOutlined /> : <CopyOutlined />}
                        </span>
                      )}
                    </span>
                  </div>
                )}
                {/* <div className="view-detail-row">
                  <label>Booking Page Link</label>
                  <span className="view-field-value">
                    {partnerDataInUpdate?.page_url || "-"}
                  </span>
                </div> */}
                {/* Slug Name \u2014 NEW */}
                <div className="view-detail-row">
                  <label>Partner Slug Name</label>
                  <span className="view-field-value" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {partnerDataInUpdate?.slug_name || "-"}
                    {partnerDataInUpdate?.slug_name && (
                      <span
                        title={copiedSlug ? "Copied!" : "Copy Slug Name"}
                        onClick={() => {
                          navigator.clipboard.writeText(partnerDataInUpdate.slug_name);
                          setCopiedSlug(true);
                          setTimeout(() => setCopiedSlug(false), 1800);
                        }}
                        style={{ cursor: "pointer", color: copiedSlug ? "#008385" : "#aaa", fontSize: 13, transition: "color 0.2s", flexShrink: 0 }}
                      >
                        {copiedSlug ? <CheckOutlined /> : <CopyOutlined />}
                      </span>
                    )}
                  </span>
                </div>

                <div className="view-detail-row">
                  <label>Clinic Label</label>
                  <span className="view-field-value">
                    {partnerDataInUpdate?.clinic_label || "-"}
                  </span>
                </div>
                <div className="view-detail-row">
                  <label>Hide Consultation Form</label>
                  <span className="view-field-value">
                    {partnerDataInUpdate?.hide_consultation_form ? "Yes" : "No"}
                  </span>
                </div>

                {/* Section: Settings */}
                {/* <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#008385",
                    letterSpacing: 1,
                    textTransform: "uppercase",
                    margin: "12px 0 8px",
                    paddingBottom: 4,
                    borderBottom: "1px solid #c5e8e8",
                  }}
                >
                  Settings
                </div> */}
                {/* requires_employee_number intentionally absent */}
                {/* <div className="view-detail-row">
                  <label>Allow Booking for CSR</label>
                  <span className="view-field-value">
                    {partnerDataInUpdate?.allow_for_admin ? "Yes" : "No"}
                  </span>
                </div> */}

                {/* Category Customizations — View Mode */}
                {Array.isArray(partnerDataInUpdate?.category_customization) &&
                  partnerDataInUpdate.category_customization.length > 0 && (
                    <>
                      <div
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: "#008385",
                          letterSpacing: 1,
                          // textTransform: "uppercase",
                          margin: "12px 0 8px",
                          paddingBottom: 4,
                          borderBottom: "1px solid #c5e8e8",
                        }}
                      >
                        Category Customizations
                      </div>
                      {partnerDataInUpdate.category_customization.map((cat, idx) => (
                        <div
                          key={idx}
                          style={{
                            background: "#f7fafa",
                            border: "1px solid #c5e8e8",
                            borderRadius: 6,
                            padding: "8px 12px",
                            marginBottom: 8,
                          }}
                        >
                          <div className="view-detail-row">
                            <label>Category</label>
                            <span className="view-field-value">
                              {productCategories.find(
                                (c) => Number(c.product_category_id) === Number(cat.product_category_id)
                              )?.name ?? cat.product_category_id ?? "-"}
                            </span>
                          </div>
                          <div className="view-detail-row">
                            <label>Change Category Label</label>
                            <span className="view-field-value">{cat.change_category_label ? "Yes" : "No"}</span>
                          </div>
                          {cat.change_category_label && (
                            <>
                              <div className="view-detail-row">
                                <label>Category Label</label>
                                <span className="view-field-value">{cat.product_category_label || "-"}</span>
                              </div>
                              <div className="view-detail-row">
                                <label>Category Description</label>
                                <span className="view-field-value">{cat.product_category_description || "-"}</span>
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                    </>
                  )}

                {/* View-mode action buttons */}
                <div
                  style={{
                    display: "flex",
                    gap: 12,
                    marginTop: 20,
                    paddingBottom: 4,
                  }}
                >
                  <Button
                    onClick={() => {
                      form.setFieldsValue({
                        name: "",
                        email: "",
                        slug_name: "",
                        intranet_url: "",
                        page_url: "",
                        allow_for_admin: false,
                        hide_consultation_form: false,
                        clinic_label: "",
                        non_gp_product_ids: [],
                        widget_url: "",
                      });
                      setCategoryCustomizations([]);
                      setProductRequiredError(false);
                      setisPartnerCreateEnable(false);
                      setSelected([]);
                      setFileList([]);
                      setshowAddButton(true);
                      setPartnerDataInUpdate({});
                      setIsViewMode(false);
                    }}
                    style={{
                      borderColor: "#008385",
                      color: "#008385",
                      minWidth: 100,
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="edit-btn-green"
                    icon={<EditOutlined />}
                    onClick={() => {
                      setIsViewMode(false);
                      setIsSlugEditing(false);
                    }}
                    style={{ minWidth: 100 }}
                  >
                    Edit
                  </Button>
                </div>
              </div>
            ) : (
              /* — EDIT / CREATE MODE — */
              !loader && (
                <Form
                  layout="vertical"
                  onFinish={(values) => {
                    let hasError = false;
                    if (categoryCustomizations.length === 0) {
                      setCategoryCustomizationError(true);
                      hasError = true;
                    }
                    const totalProducts = categoryCustomizations.flatMap(c => c.non_gp_product_ids || []).length;
                    if (totalProducts === 0) {
                      setProductRequiredError(true);
                      hasError = true;
                    }
                    if (hasError) return;
                    handlePartnerCreate(values, isEditingExistingPartner);
                  }}
                  form={form}
                  initialValues={
                    partnerDataInUpdate ? partnerDataInUpdate : null
                  }
                >
                  {/* Row 1: Partner Name + Company Email */}
                  <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item
                        label="Partner Name:"
                        name="name"
                        rules={[
                          {
                            required: !isViewMode,
                            message: "Partner Name is required.",
                          },
                        ]}
                      >
                        <Input
                          disabled={isViewMode}
                          style={{ width: "100%" }}
                          placeholder="Partner Name"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Company Email:"
                        name="email"
                        rules={[
                          {
                            message: "Please enter valid email address.",
                            type: "email",
                          },
                        ]}
                      >
                        <Input
                          disabled={isViewMode}
                          style={{ width: "100%" }}
                          placeholder="email"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* Row 2: Slug Name + Company Logo */}
                  <Row gutter={24}>
                    <Col span={12}>
                      {/*
                        Layout: outer Form.Item owns the label + error display.
                        Inner Form.Item (noStyle) owns the form binding so `value`
                        is injected directly into <Input>, fixing the blank-in-edit bug.

                        Behaviour in edit mode:
                          â€¢ Default  â†’ slug input is DISABLED + shows an "Edit" button
                          â€¢ After clicking Edit â†’ slug input becomes EDITABLE + shows
                            "Update Slug Name" button (calls handleUpdateSlug on click)
                      */}
                      <Form.Item label="Slug Name:">
                        <div className="slug-field-wrapper">
                          <Form.Item
                            name="slug_name"
                            noStyle
                            normalize={(value) => value?.replace(/ /g, "-") ?? ""}
                            rules={[
                              {
                                required: !isViewMode,
                                message: "Slug name is required.",
                              },
                            ]}
                          >
                            <Input
                              disabled={isViewMode || (isEditingExistingPartner && !isSlugEditing)}
                              style={{ width: "100%" }}
                              placeholder="e.g. spire-uk"
                              onChange={() => {
                                if (recommendedSlug) setRecommendedSlug("");
                                if (isSlugValidated) setIsSlugValidated(false);
                              }}
                            />
                          </Form.Item>

                          {/* Existing partner â€” show Edit OR Update Slug Name */}
                          {isEditingExistingPartner && !isViewMode && (
                            !isSlugEditing ? (
                              /* â”€â”€ Edit button (default state) â”€â”€ */
                              <Button
                                icon={<EditOutlined />}
                                onClick={() => setIsSlugEditing(true)}
                                style={{
                                  borderColor: "#008385",
                                  color: "#008385",
                                  height: 32,
                                  flexShrink: 0,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Edit
                              </Button>
                            ) : (
                              /* â”€â”€ Update Slug Name button (editing state) â”€â”€ */
                              <Button
                                loading={isSlugUpdating}
                                disabled={isSlugUpdating}
                                onClick={async () => {
                                  await handleUpdateSlug();
                                  setIsSlugEditing(false);
                                }}
                                style={{
                                  borderColor: "#008385",
                                  color: "#008385",
                                  height: 32,
                                  flexShrink: 0,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Update Slug
                              </Button>
                            )
                          )}

                          {/* Add mode — Validate Slug button */}
                          {!isEditingExistingPartner && !isViewMode && (
                            <Button
                              loading={isSlugUpdating}
                              disabled={isSlugUpdating}
                              onClick={handleValidateSlug}
                              style={{
                                borderColor: isSlugValidated ? "#52c41a" : "#008385",
                                color: isSlugValidated ? "#52c41a" : "#008385",
                                height: 32,
                                flexShrink: 0,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {isSlugValidated ? "✓ Validated" : "Validate Slug"}
                            </Button>
                          )}
                        </div>
                      </Form.Item>

                      {/* Quick-apply button: shown when backend returns a recommendedSlug */}
                      {recommendedSlug && !isViewMode && (
                        <div style={{ marginTop: 4, marginBottom: 8 }}>
                          <Button
                            size="small"
                            type="link"
                            style={{ padding: 0, color: "#008385", fontSize: 12 }}
                            onClick={() => {
                              form.setFieldsValue({ slug_name: recommendedSlug });
                              form.setFields([{ name: "slug_name", errors: [] }]);
                              setRecommendedSlug("");
                            }}
                          >
                            Use suggested: <strong>{recommendedSlug}</strong>
                          </Button>
                        </div>
                      )}
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Company Logo:"
                        name="company_logo"
                        rules={[{ required: false }]}
                        className="customer-logo"
                      >
                        <Upload
                          disabled={isViewMode}
                          listType="picture-card"
                          onChange={handleChange}
                          maxCount={1}
                          beforeUpload={beforeUpload}
                          fileList={fileList}
                          accept="image/*"
                          showUploadList={{
                            showPreviewIcon: false,
                            showRemoveIcon: true,
                            showDownloadIcon: false,
                          }}
                        >
                          <Input
                            placeholder={
                              Object.keys(partnerDataInUpdate)?.length > 0 ||
                                fileList?.length > 0
                                ? fileList?.length > 0
                                  ? fileList[0]?.name
                                  : "Upload logo"
                                : "Upload logo"
                            }
                            value={
                              Object.keys(partnerDataInUpdate)?.length > 0 &&
                                fileList?.length === 0
                                ? ""
                                : ""
                            }
                            readOnly
                            suffix={<PaperClipOutlined />}
                            style={{ cursor: "pointer" }}
                          />
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* Row 3: Clinic Label + Hide Consultation Form */}
                  <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item
                        label="Clinic Label:"
                        name="clinic_label"
                        rules={[
                          {
                            max: 50,
                            message: "The clinic label may not be greater than 50 characters.",
                          },
                        ]}
                      >
                        <Input
                          disabled={isViewMode}
                          style={{ width: "100%" }}
                          placeholder="e.g. Medical Center"
                          maxLength={50}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      span={12}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingTop: 8,
                      }}
                    >
                      <Form.Item
                        name="hide_consultation_form"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox disabled={isViewMode}>
                          Hide Consultation Form
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* Row 5: Intranet URL */}
                  {/* <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item
                        label="Intranet url:"
                        name="intranet_url"
                        rules={[{ required: false }]}
                      >
                        <Input
                          disabled={isViewMode}
                          style={{ width: "100%" }}
                          placeholder="Intranet url"
                        />
                      </Form.Item>
                    </Col>
                  </Row> */}

                  {/* Row 6: Booking Widget Link (existing records only) */}
                  <Row gutter={24}>
                    <Col span={12}>
                      {Object.keys(partnerDataInUpdate).length > 0 &&
                        showWidgetField && (
                          <Form.Item
                            label="Booking widget id:"
                            name="widget_url"
                          >
                            <Input
                              suffix={
                                copied ? (
                                  <span style={{ color: "green", fontSize: 12 }}>
                                    <CheckOutlined /> Copied
                                  </span>
                                ) : (
                                  <CopyOutlined
                                    style={{
                                      cursor: "pointer",
                                      color: "#1677ff",
                                    }}
                                    onClick={handleCopy}
                                  />
                                )
                              }
                              style={{ width: "100%" }}
                              placeholder="Booking widget id"
                              disabled
                            />
                          </Form.Item>
                        )}
                    </Col>
                  </Row>

                  {/* Row 7: Booking Page Link */}
                  {/* <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item
                        label="Booking page link:"
                        name="page_url"
                        rules={[{ required: false }]}
                      >
                        <Input
                          disabled={isViewMode}
                          style={{ width: "100%" }}
                          placeholder="Booking page link"
                        />
                      </Form.Item>
                    </Col>
                  </Row> */}

                  {/* Row 8: Allow Booking for CSR (retained) */}
                  {/* <Row gutter={24}>
                    <Col
                      style={{ display: "flex", justifyContent: "left" }}
                      span={12}
                    >
                      <Form.Item
                        name="allow_for_admin"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Checkbox disabled={isViewMode}>
                          Allow booking for CSR
                        </Checkbox>
                      </Form.Item>
                    </Col>
                   </Row> */}

                  {/* â”€â”€ Category Customization Section â”€â”€ */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      margin: "16px 0 14px",
                      padding: "10px 14px",
                      background: categoryCustomizationError
                        ? "linear-gradient(90deg, #fff1f0 0%, #fff7f7 100%)"
                        : "linear-gradient(90deg, #e6f7f7 0%, #f0fafa 100%)",
                      borderLeft: `4px solid ${categoryCustomizationError ? "#ff4d4f" : "#008385"}`,
                      borderRadius: "0 6px 6px 0",
                    }}
                  >
                    <span style={{ fontSize: 15, color: categoryCustomizationError ? "#ff4d4f" : "#008385" }}>&#9881;</span>
                    <span
                      style={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: categoryCustomizationError ? "#ff4d4f" : "#008385",
                        letterSpacing: 1.2,
                      }}
                    >
                      Category Customization<span style={{ color: "#ff4d4f", marginLeft: 0 }}>*</span>

                    </span>
                    {categoryCustomizationError && (
                      <span
                        style={{
                          marginLeft: "auto",
                          fontSize: 11,
                          color: "#ff4d4f",
                          fontWeight: 600,
                        }}
                      >
                        At least 1 category is required
                      </span>
                    )}
                  </div>

                  {/* â”€â”€ Simplified Category + Product Section â”€â”€ */}
                  {(() => {
                    // â”€â”€ Derived values â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
                    // isAllCats: driven by the isCategoryAllMode flag (set by category dropdown)
                    const isAllCats = isCategoryAllMode;
                    const selectedCatIds = isAllCats
                      ? []
                      : categoryCustomizations
                        .filter(c => c.product_category_id != null)
                        .map(c => Number(c.product_category_id));

                    // All product IDs across all blocks (flat)
                    const allSelectedProductIds = categoryCustomizations
                      .flatMap(c => c.non_gp_product_ids || []);

                    // Products available in the product dropdown
                    const availableProducts = (isAllCats || selectedCatIds.length === 0)
                      ? (corporateProducts || [])
                      : (corporateProducts || []).filter(p =>
                        selectedCatIds.includes(Number(p.product_category_id))
                      );

                    // Filtered by search term
                    const displayedProducts = availableProducts.filter(p =>
                      p.name.toLowerCase().includes(searchValue.toLowerCase())
                    );

                    // Category select value â€” always "all" when in all mode
                    const categorySelectVal = isAllCats ? ["all"] : selectedCatIds;

                    // â”€â”€ Rebuild helper: split selected products into per-category entries â”€â”€
                    const rebuildPerCategory = (selectedIds, currentCustomizations) => {
                      if (!selectedIds || selectedIds.length === 0) {
                        return [{
                          product_category_id: null,
                          product_category_label: "",
                          product_category_description: "",
                          change_category_label: false,
                          exclude_category: false,
                          non_gp_product_ids: [],
                        }];
                      }
                      // Detect unique category IDs from the selected products
                      const catIdSet = new Set(
                        selectedIds
                          .map(pid => corporateProducts?.find(p => p.non_gp_product_id === pid)?.product_category_id)
                          .filter(id => id != null)
                          .map(Number)
                      );
                      if (catIdSet.size === 0) {
                        return [{
                          product_category_id: null,
                          product_category_label: "",
                          product_category_description: "",
                          change_category_label: false,
                          exclude_category: false,
                          non_gp_product_ids: selectedIds,
                        }];
                      }
                      // Order by productCategories array order
                      const orderedCatIds = (productCategories || [])
                        .map(c => Number(c.product_category_id))
                        .filter(id => catIdSet.has(id));
                      return orderedCatIds.map(catId => {
                        const existing = (currentCustomizations || []).find(
                          c => c.product_category_id != null &&
                            Number(c.product_category_id) === Number(catId)
                        );
                        const catProducts = selectedIds.filter(pid => {
                          const gp = corporateProducts?.find(p => p.non_gp_product_id === pid);
                          return Number(gp?.product_category_id) === catId;
                        });
                        return {
                          product_category_id: catId,
                          product_category_label: existing?.product_category_label || "",
                          product_category_description: existing?.product_category_description || "",
                          change_category_label: existing?.change_category_label || false,
                          exclude_category: existing?.exclude_category || false,
                          non_gp_product_ids: catProducts,
                        };
                      });
                    };

                    // â”€â”€ Category multi-select change â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
                    const handleCategoryChange = (vals) => {
                      if (!vals || vals.length === 0 || vals.includes("all")) {
                        setIsCategoryAllMode(true);
                        // Rebuild per-category entries from currently selected products
                        const allIds = categoryCustomizations.flatMap(c => c.non_gp_product_ids || []);
                        setCategoryCustomizations(rebuildPerCategory(allIds, categoryCustomizations));
                      } else {
                        setIsCategoryAllMode(false);
                        const specificVals = vals.filter(v => v !== "all").map(Number);
                        const newEntries = specificVals.map(catId => {
                          const existing = categoryCustomizations.find(
                            c => c.product_category_id != null &&
                              Number(c.product_category_id) === Number(catId)
                          );
                          if (existing) return existing;
                          const matchingIds = (corporateProducts || [])
                            .filter(p => Number(p.product_category_id) === catId &&
                              allSelectedProductIds.includes(p.non_gp_product_id))
                            .map(p => p.non_gp_product_id);
                          return {
                            product_category_id: catId,
                            product_category_label: "",
                            product_category_description: "",
                            change_category_label: false,
                            exclude_category: false,
                            non_gp_product_ids: matchingIds,
                          };
                        });
                        setCategoryCustomizations(newEntries);
                      }
                      if (categoryCustomizationError) setCategoryCustomizationError(false);
                    };

                    // â”€â”€ Product multi-select change â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
                    const handleProductChange = (selectedIds) => {
                      let updated;
                      if (isCategoryAllMode) {
                        // In All mode: auto-split by detected categories
                        updated = rebuildPerCategory(selectedIds, categoryCustomizations);
                      } else {
                        // Specific mode: distribute to respective category blocks
                        updated = categoryCustomizations.map(cat => {
                          const blockProducts = selectedIds.filter(pid => {
                            const gp = corporateProducts?.find(p => p.non_gp_product_id === pid);
                            return Number(gp?.product_category_id) === Number(cat.product_category_id);
                          });
                          return { ...cat, non_gp_product_ids: blockProducts };
                        });
                      }
                      setCategoryCustomizations(updated);
                      const allIds = updated.flatMap(c => c.non_gp_product_ids || []);
                      setSelected(allIds);
                      form.setFieldsValue({ non_gp_product_ids: allIds });
                    };

                    // â”€â”€ Options for Select tag-label resolution â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
                    const catSelectOptions = [
                      { label: "All", value: "all" },
                      ...(productCategories || []).map(c => ({
                        label: c.name,
                        value: Number(c.product_category_id),
                      })),
                    ];
                    const productSelectOptions = availableProducts.map(p => ({
                      label: p.name,
                      value: p.non_gp_product_id,
                    }));

                    // â”€â”€ Category names shown as badge chips next to "Product:" â”€â”€
                    const selectedCatNames = (() => {
                      const entries = categoryCustomizations.filter(c =>
                        c.product_category_id != null && (c.non_gp_product_ids || []).length > 0
                      );
                      return entries
                        .map(c => (productCategories || []).find(
                          pc => Number(pc.product_category_id) === Number(c.product_category_id)
                        )?.name)
                        .filter(Boolean);
                    })();

                    return (
                      <div
                        style={{
                          background: "#ffffff",
                          border: "1px solid #c5e8e8",
                          borderLeft: "4px solid #008385",
                          borderRadius: 8,
                          padding: "16px 16px 12px 16px",
                          marginBottom: 14,
                          boxShadow: "0 2px 8px rgba(0,131,133,0.07)",
                        }}
                      >
                        {/* Category + Product row */}
                        <Row gutter={16} style={{ marginBottom: 12 }} align="bottom">

                          {/* â”€â”€ Category multi-select (custom checkbox dropdown) â”€â”€ */}
                          <Col span={12}>
                            <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#4a5568", marginBottom: 5, letterSpacing: 0.5 }}>
                              Category:
                            </label>
                            <Select
                              mode="multiple"
                              disabled={isViewMode}
                              style={{ width: "100%", height: 32 }}
                              placeholder="Select categories"
                              value={categorySelectVal}
                              options={catSelectOptions}
                              maxTagCount="responsive"
                              open={openDropdownIdx === -1}
                              onDropdownVisibleChange={(open) => {
                                setOpenDropdownIdx(open ? -1 : null);
                                if (open) setCatSearchValue("");
                              }}
                              dropdownRender={() => {
                                const filteredCats = (productCategories || []).filter(c =>
                                  c.name.toLowerCase().includes(catSearchValue.toLowerCase())
                                );
                                return (
                                  <div>
                                    {/* Search input inside dropdown */}
                                    <div style={{ padding: "8px 8px 4px" }}>
                                      <Input
                                        size="small"
                                        placeholder="Search categories..."
                                        value={catSearchValue}
                                        onChange={(e) => setCatSearchValue(e.target.value)}
                                        onClick={(e) => e.stopPropagation()}
                                        prefix={<SearchOutlined style={{ color: "#bbb", fontSize: 12 }} />}
                                        allowClear
                                      />
                                    </div>
                                    <div style={{ maxHeight: 220, overflowY: "auto", padding: "0 8px 8px" }}>
                                      {/* All option */}
                                      <div style={{ padding: "3px 4px", borderBottom: "1px solid #f0f0f0", marginBottom: 4 }}>
                                        <Checkbox
                                          disabled={isViewMode}
                                          checked={isAllCats}
                                          onChange={(e) => { if (e.target.checked) handleCategoryChange(["all"]); }}
                                        >
                                          <strong>All</strong>
                                        </Checkbox>
                                      </div>
                                      {filteredCats.length ? (
                                        filteredCats.map((c) => {
                                          const catNum = Number(c.product_category_id);
                                          const isChecked = !isAllCats && selectedCatIds.includes(catNum);
                                          return (
                                            <div key={catNum} style={{ padding: "3px 4px" }}>
                                              <Checkbox
                                                disabled={isViewMode}
                                                checked={isChecked}
                                                onChange={(e) => {
                                                  const newVals = e.target.checked
                                                    ? [...selectedCatIds, catNum]
                                                    : selectedCatIds.filter(id => id !== catNum);
                                                  handleCategoryChange(newVals);
                                                }}
                                              >
                                                {c.name}
                                              </Checkbox>
                                            </div>
                                          );
                                        })
                                      ) : (
                                        <div style={{ padding: "8px 12px", color: "#999" }}>No categories found</div>
                                      )}
                                    </div>
                                  </div>
                                );
                              }}
                              maxTagPlaceholder={(omitted) => `+${omitted.length} more`}
                              onChange={handleCategoryChange}
                            />
                          </Col>

                          {/* â”€â”€ Product multi-select (custom checkbox dropdown) â”€â”€ */}
                          <Col span={12}>
                            <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#4a5568", marginBottom: 5, letterSpacing: 0.5 }}>
                              Product:
                            </label>
                            <Select
                              mode="multiple"
                              disabled={isViewMode}
                              style={{ width: "100%", height: 32 }}
                              placeholder="Select products"
                              value={allSelectedProductIds}
                              options={productSelectOptions}
                              maxTagCount="responsive"
                              open={openDropdownIdx === 0}
                              onDropdownVisibleChange={(open) => {
                                setOpenDropdownIdx(open ? 0 : null);
                                if (open) setSearchValue("");
                              }}
                              dropdownRender={() => (
                                <div>
                                  {/* Search input inside dropdown */}
                                  <div style={{ padding: "8px 8px 4px" }}>
                                    <Input
                                      size="small"
                                      placeholder="Search products..."
                                      value={searchValue}
                                      onChange={(e) => setSearchValue(e.target.value)}
                                      onClick={(e) => e.stopPropagation()}
                                      prefix={<SearchOutlined style={{ color: "#bbb", fontSize: 12 }} />}
                                      allowClear
                                    />
                                  </div>
                                  <div style={{ maxHeight: 220, overflowY: "auto", padding: "0 8px 8px" }}>
                                    {displayedProducts?.length ? (
                                      displayedProducts.map((clType) => (
                                        <div key={clType.non_gp_product_id} style={{ padding: "3px 4px" }}>
                                          <Checkbox
                                            disabled={isViewMode}
                                            checked={allSelectedProductIds.includes(clType.non_gp_product_id)}
                                            onChange={(e) => {
                                              const pid = clType.non_gp_product_id;
                                              const newIds = e.target.checked
                                                ? [...allSelectedProductIds, pid]
                                                : allSelectedProductIds.filter(id => id !== pid);
                                              handleProductChange(newIds);
                                            }}
                                          >
                                            {clType.name}
                                          </Checkbox>
                                        </div>
                                      ))
                                    ) : (
                                      <div style={{ padding: "8px 12px", color: "#999" }}>No products found</div>
                                    )}
                                  </div>
                                </div>
                              )}
                              maxTagPlaceholder={(omitted) => `+${omitted.length} more`}
                              onChange={(ids) => {
                                handleProductChange(ids);
                                if (ids.length > 0) setProductRequiredError(false);
                              }}
                            />
                            {productRequiredError && (
                              <span style={{ color: "#ff4d4f", fontSize: 11, fontWeight: 500, marginTop: 4, display: "block" }}>
                                At least 1 product is required
                              </span>
                            )}
                          </Col>
                        </Row>

                        {/* â”€â”€ Per-category label customization rows â”€â”€ */}
                        {categoryCustomizations
                          .filter(cat => cat.product_category_id != null)
                          .map((cat, idx) => {
                            const catName = (productCategories || []).find(
                              c => Number(c.product_category_id) === Number(cat.product_category_id)
                            )?.name || "";

                            // Index in the real categoryCustomizations array (for state updates)
                            const realIdx = categoryCustomizations.indexOf(cat);

                            return (
                              <div key={cat.product_category_id} style={{ marginTop: 20, position: "relative", border: "1px solid #b2e0e0", borderRadius: 8, padding: "18px 12px 12px", background: "#fafefe" }}>
                                {/* Category N label sits ON the border */}
                                <span style={{ position: "absolute", top: -12, left: 10, background: "#008385", color: "#fff", borderRadius: 20, padding: "2px 10px", fontSize: 11, fontWeight: 700, letterSpacing: 0.5 }}>
                                  Category {idx + 1}
                                </span>
                                {/* Category name badge + Change category label â€” one row */}
                                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: cat.change_category_label ? 10 : 0 }}>

                                  {/* Category name badge */}
                                  <div style={{ flex: 1, display: "flex", alignItems: "center", padding: "5px 0", minHeight: 32, gap: 8 }}>
                                    {cat.change_category_label && cat.product_category_label && (
                                      <span style={{ background: "#008385", color: "#fff", borderRadius: 4, padding: "1px 8px", fontSize: 11, fontWeight: 700 }}>
                                        {cat.product_category_label}
                                      </span>
                                    )}
                                    {cat.change_category_label && cat.product_category_label && (
                                      <span style={{ color: "#aaa", fontSize: 13 }}>|</span>
                                    )}
                                    <span style={{ fontSize: 12, color: "#4a5568", fontWeight: 500 }}>{catName}</span>
                                  </div>

                                  {/* Change category label toggle */}
                                  <div
                                    style={{ display: "flex", alignItems: "center", gap: 7, background: cat.change_category_label ? "#008385" : "#f5f5f5", border: `1px solid ${cat.change_category_label ? "#008385" : "#d9d9d9"}`, borderRadius: 20, padding: "4px 14px 4px 10px", cursor: isViewMode ? "default" : "pointer", whiteSpace: "nowrap", transition: "all 0.2s" }}
                                    onClick={() => {
                                      if (isViewMode) return;
                                      const updated = [...categoryCustomizations];
                                      updated[realIdx] = { ...updated[realIdx], change_category_label: !cat.change_category_label };
                                      setCategoryCustomizations(updated);
                                    }}
                                  >
                                    <Checkbox disabled={isViewMode} checked={!!cat.change_category_label} style={{ pointerEvents: "none" }} />
                                    <span style={{ fontSize: 12, fontWeight: 600, color: cat.change_category_label ? "#fff" : "#4a5568" }}>
                                      Change category label
                                    </span>
                                  </div>

                                  {/* Exclude category toggle */}
                                  <div
                                    style={{ display: "flex", alignItems: "center", gap: 7, background: cat.exclude_category ? "#008385" : "#f5f5f5", border: `1px solid ${cat.exclude_category ? "#008385" : "#d9d9d9"}`, borderRadius: 20, padding: "4px 14px 4px 10px", cursor: isViewMode ? "default" : "pointer", whiteSpace: "nowrap", transition: "all 0.2s" }}
                                    onClick={() => {
                                      if (isViewMode) return;
                                      const updated = [...categoryCustomizations];
                                      updated[realIdx] = { ...updated[realIdx], exclude_category: !cat.exclude_category };
                                      setCategoryCustomizations(updated);
                                    }}
                                  >
                                    <Checkbox disabled={isViewMode} checked={!!cat.exclude_category} style={{ pointerEvents: "none" }} />
                                    <span style={{ fontSize: 12, fontWeight: 600, color: cat.exclude_category ? "#fff" : "#4a5568" }}>
                                      Main Widget Exclusion
                                    </span>
                                  </div>
                                </div>

                                {/* Label + Description inputs (conditional) */}
                                {cat.change_category_label && (
                                  <Row gutter={16}>
                                    <Col span={12}>
                                      <Form.Item
                                        label={<span style={{ fontSize: 12, fontWeight: 600, color: "#4a5568" }}>Category Label<span style={{ color: "#ff4d4f", marginRight: 1 }}>*</span>:</span>}
                                        required={false}
                                        style={{ marginBottom: 0 }}
                                      >
                                        <Input
                                          disabled={isViewMode}
                                          value={cat.product_category_label}
                                          placeholder="e.g. Spire Healthcare appointments"
                                          onChange={(e) => {
                                            const updated = [...categoryCustomizations];
                                            updated[realIdx] = { ...updated[realIdx], product_category_label: e.target.value };
                                            setCategoryCustomizations(updated);
                                          }}
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                      <Form.Item
                                        label={<span style={{ fontSize: 12, fontWeight: 600, color: "#4a5568" }}>Category Description:</span>}
                                        style={{ marginBottom: 0 }}
                                      >
                                        <Input
                                          disabled={isViewMode}
                                          value={cat.product_category_description}
                                          placeholder="e.g. Spire Healthcare appointments"
                                          onChange={(e) => {
                                            const updated = [...categoryCustomizations];
                                            updated[realIdx] = { ...updated[realIdx], product_category_description: e.target.value };
                                            setCategoryCustomizations(updated);
                                          }}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                )}
                              </div>
                            );
                          })
                        }
                      </div>
                    );
                  })()}

                  {/* Hidden Form.Item keeps non_gp_product_ids in the form model for validation */}
                  {/* Only the Select input is hidden; Form.Item stays visible so error message shows */}
                  <Form.Item
                    name="non_gp_product_ids"
                    rules={[{ required: !isViewMode, message: "At least 1 Product is required." }]}
                    style={{ marginBottom: 0 }}
                  >
                    <div style={{ display: "none" }}>
                      <Select mode="multiple" />
                    </div>
                  </Form.Item>

                  {/* requires_employee_number checkbox is intentionally REMOVED */}

                  {/* Form actions */}
                  {!isViewMode && (
                    <>
                      <Button
                        disabled={isSubmitting}
                        loading={isSubmitting}
                        type="primary"
                        htmlType="submit"
                        style={{
                          marginTop: 10,
                          backgroundColor: "#008385",
                          width: "174px",
                          marginRight: 10,
                          height: "40px",
                          color: "white",
                        }}
                      >
                        {isSubmitting ? "Saving..." : "Save"}
                      </Button>
                      <Button
                        key="cancel-edit-btn"
                        type="primary"
                        htmlType="button"
                        className="add-generic-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          form.setFieldsValue({
                            name: "",
                            email: "",
                            slug_name: "",
                            intranet_url: "",
                            page_url: "",
                            allow_for_admin: false,
                            hide_consultation_form: false,
                            clinic_label: "",
                            non_gp_product_ids: [],
                            widget_url: "",
                          });
                          setCategoryCustomizations([]);
                          setProductRequiredError(false);
                          setisPartnerCreateEnable(false);
                          setSelected([]);
                          setFileList([]);
                          setshowAddButton(true);
                          setPartnerDataInUpdate({});
                          setIsViewMode(false);
                        }}
                        style={{
                          marginTop: 10,
                          backgroundColor: "#fafefeff",
                          width: "174px",
                          height: "40px",
                        }}
                      >
                        Cancel
                      </Button>
                    </>
                  )}
                </Form>
              )
            )}
          </Card>
        </div>
      )}
    </App>
  );
};

export default Partner;
